import type { ReceiptWidthMm } from '@vuelto/print';
import { printHtmlDocument } from '../../../shared/print/printHtmlDocument';

export async function browserPrintTransport(args: {
  html: string;
  text?: string;
  downloadFilename?: string;
  widthMm?: ReceiptWidthMm;
}): Promise<void> {
  await printHtmlDocument(args.html, {
    plainText: args.text,
    downloadFilename: args.downloadFilename,
    widthMm: args.widthMm,
  });
}